import { useModal } from 'hooks/useModal';
import Modal, { ModalProps } from './Modal';

export type { ModalProps };
export { useModal };

export default Modal;
